// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1807":"css/app.6880","4474":"css/admin-app.6880"}[chunkId] + ".css";
};